<template>
  <div class="consumer-info-header container-fluid" v-if="consumer !== null">
    <div class="row d-flex d-sm-none">
      <div class="logo-holder">
          <img :src="`${publicPath}${currentLogo}`" />
      </div>
      <div class="managed-by">{{managedByText}} {{consumer.provider_name}}</div>
      <div class="back-button-holder">
        <button class="btn btn-secondary back-button" @click="back" v-if="showBack">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" stroke="white" stroke-width="1" />
          </svg>
        Back
        </button></div>
    </div>
    <div class="row">
      <div class="col-sm-2 col-lg-3 left-side fixed-top d-none d-sm-flex">
        <div class="fixed-container-wrapper">
        <div class="fixed-container">
        <div class="logo-holder">
            <img :src="`${publicPath}${currentLogo}`" />
        </div>
        <div class="managed-by">{{managedByText}} {{consumer.provider_name}}</div>
        <div class="back-button-holder">
          <button class="btn btn-secondary back-button" @click="back" v-if="showBack">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" stroke="white" stroke-width="1" />
            </svg>
          Back
          </button></div>
        </div>
        </div>
      </div>
      <div class="col-sm-4 info-column-left">
        <ValueDisplay v-for="displayField in firstHalfFields" :label="displayField.label" :value="getValueDisplay()(displayField.field, info[displayField.field])" :key="displayField.field"></ValueDisplay>
      </div>
      <div class="col-sm-4 info-column-right">
        <ValueDisplay v-for="displayField in secondHalfFields" :label="displayField.label" :value="getValueDisplay()(displayField.field, info[displayField.field])" :key="displayField.field"></ValueDisplay>
      </div>
      <div class="col-sm-2 col-lg-1 right-side d-none d-sm-flex">
        <div class="fixed-container-wrapper-right">
        <div class="fixed-container-right">
        <div class="pull-right" style="white-space:nowrap">
          <clock></clock>
        </div>
        <br/>
        <div class="pull-right" style="white-space:nowrap">
          <strong>CID:</strong> {{consumer.id}}
        </div>
        <div class="end-call-button-holder" v-show="!$route.path.toUpperCase().includes('SUCCESS')">
          <button class="btn btn-secondary not-interested pull-right" @click="notInterested" :disabled="!leadSaved" v-show="$route.name === 'Consumer Information' && consumer.has_leads_offers">Not Interested</button>
          <button class="btn btn-danger end-call pull-right" @click="endCall">End Session</button>
        </div>
        </div>
        </div>
      </div>
    </div>
    <div class="row d-flex d-sm-none">
      <div class="pull-right" style="white-space:nowrap">
        <clock></clock>
      </div>
      <br/>
      <div class="pull-right" style="white-space:nowrap">
        <strong>CID:</strong> {{consumer.id}}
      </div>
      <div class="end-call-button-holder" v-show="!$route.path.toUpperCase().includes('SUCCESS')">
        <button class="btn btn-secondary back-button" @click="back" v-if="backPath !== null">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" stroke="white" stroke-width="1" />
          </svg>
        Back
        </button>
        <button class="btn btn-secondary not-interested pull-right" @click="notInterested" :disabled="!leadSaved" v-show="$route.name === 'Consumer Information' && consumer.has_leads_offers">Not Interested</button>
        <button class="btn btn-danger end-call pull-right" @click="endCall">End Session</button>
      </div>
    </div>
  </div>
  <div class="consumer-info-header container-fluid" v-else-if="$route.name === 'Invalid Portal'">
    <div class="row">
      <div class="col-sm-2 col-lg-3 left-side fixed-top d-flex">
        <div class="fixed-container-wrapper">
        <div class="fixed-container">
        <div class="logo-holder">
            <img :src="`${publicPath}${currentLogo}`" />
        </div>
        <div class="managed-by" v-if="consumer">{{managedByText}} {{consumer.provider_name}}</div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import ValueDisplay from './basic-elements/ValueDisplay.vue'
import Clock from '../components/basic-elements/Clock.vue'

export default {
  name: 'InfoHeader',
  components: {
    ValueDisplay,
    Clock
  },
  props: ['routeBack'],
  data () {
    return {
      publicPath: process.env.BASE_URL,
      currentLogo: `${process.env.VUE_APP_LOGO}`,
      managedByText: process.env.VUE_APP_MANAGED_BY_TEXT
    }
  },
  methods: {
    back () {
      if (!this.noPendingBulk) {
        if (confirm('If you go Back all selected schools will be removed from the queue.')) {
          this.clearPendingBulk()
        } else {
          return
        }
      }
      this.$router.push(this.backPath)
    },
    async setMaxHeights () {
      setTimeout(() => {
        var header = document.getElementsByClassName('consumer-info-header')
        var app = document.getElementById('app')
        var infobox = document.getElementsByClassName('lead-info-box')
        if (header[0]) {
          var headerHeight = header[0].offsetHeight
          var content = document.getElementsByClassName('main-content')
          if (content[0]) {
            var endHeight = app.offsetHeight - headerHeight
            content[0].style.height = infobox.length && endHeight > infobox[0].offsetHeight + 20 ? `${endHeight}px` : 'auto'
          }
        }
      }, 25)
    },
    endCall () {
      if (!this.noPendingBulk) {
        if (confirm('Are you sure you want to end the session? There are offers selected to be submitted.')) {
          this.clearPendingBulk()
        } else {
          return
        }
      }
      this.$router.push(`/consumer/${this.consumer.id}/success`)
    },
    notInterested () {
      this.$router.push(`/consumer/${this.consumer.id}/extraoffers`)
    },
    ...mapGetters({
      getValueDisplay: 'consumer/additionalInfo/getValueDisplay'
    }),
    ...mapActions({
      getQuestions: 'consumer/getAdditionalQuestions'
    }),
    ...mapMutations({
      clearPendingBulk: 'consumer/leadRequests/removeAllPendingBulkSubmit'
    })
  },
  computed: {
    offerSubmits () {
      return this.submits
    },
    firstHalfFields () {
      return this.displayFields.slice(0, this.displayFields.length / 2 + this.displayFields.length % 2)
    },
    secondHalfFields () {
      return this.displayFields.slice(this.displayFields.length / 2 + this.displayFields.length % 2)
    },
    backPath () {
      if (this.routeBack && this.offerSubmits.length === 0) {
        if (typeof this.routeBack === 'function') {
          return `/consumer/${this.consumer.id}/${this.routeBack(this.consumer)}`
        }
        return `/consumer/${this.consumer.id}/${this.routeBack}`
      }
      return null
    },
    noPendingBulk () {
      return !this.pendingBulkSubmits || this.pendingBulkSubmits.length < 1
    },
    showBack () {
      return this.backPath !== null && !this.waitForOfferSubmit
    },
    ...mapState({
      consumer: state => state.consumer.currentConsumer,
      displayFields: state => state.consumer.additionalInfo.displayFields,
      pendingBulkSubmits: state => state.consumer.leadRequests.pendingBulkSubmits,
      waitForOfferSubmit: state => state.consumer.leadRequests.waitForOfferSubmit
    }),
    ...mapGetters({
      info: 'consumer/additionalInfo/getInfo',
      leadSaved: 'consumer/lead/isSaved',
      submits: 'consumer/leadRequests/getRequests'
    })
  },
  mounted () {
    this.setMaxHeights()
    window.onresize = this.setMaxHeights
  },
  watch: {
    displayFields () {
      this.setMaxHeights()
    }
  }
}
</script>
<style scoped>
.consumer-info-header {
  max-height: 126px;
  overflow: auto;
  margin-bottom: 15px;
}
.consumer-info-header > .row {
  min-height: 100px;
}
.logo-holder {
  max-width: 220px;
}
.logo-holder img {
  max-width: 85%;
}
.left-side, .right-side {
  position: relative;
}
.right-side {
  min-height: 120px;
}
button.btn {
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 14px;
}
.back-button-holder {
  position: absolute;
  bottom: 0;
}
.end-call-button-holder {
  position: absolute;
  bottom: 0;
  right: 0;
}
button.end-call {
  width: 112px;
}
button.not-interested {
  width: 112px;
  padding-right: 10px;
  padding-left: 10px;
  margin-bottom: 5px;
}
button.end-call svg {
  height: 14px;
  margin-top: -3px;
  margin-left: 7px;
}
button.back-button svg {
  height: 14px;
}
.fixed-container-wrapper {
  position: absolute;
  top: 0px;
}
.fixed-container-wrapper-right {
  position: absolute;
  top: 0px;
  right: 115px;
}
.fixed-container {
  position: fixed;
  height: 118px;
}
.fixed-container-right {
  position: fixed;
  height: 118px;
}
@media screen and (max-width: 991px) {
  .logo-holder {
    max-width: 18vw;
  }
  .managed-by {
    max-width: 16vw;
  }
}
@media screen and (max-width: 575px) {
  .logo-holder, .managed-by, .back-button-holder {
    max-width: 100%;
    background: #d9edf7;
    text-align: center;
  }
  .consumer-info-header {
    max-height: unset;
    overflow: unset;
  }
  .consumer-info-header > .row {
    max-height: 126px;
    overflow: auto;
  }
  .consumer-info-header .pull-right {
    text-align: right;
  }
  .end-call-button-holder {
    position: relative;
    right: 0;
  }
  .consumer-info-header .end-call-button-holder .pull-right {
    text-align: center;
  }
}
</style>

<style>
.consumer-info-header {
  padding: 5px 15px;
  background-color: #d9edf7;
}
</style>
